// import { machine } from '@/models/createWarehouseReceivingOrder/create-order-machine'
import { store } from '@/store'
import { ModuleName } from '@/store/modules/createWarehouseReceivingOrder'
import router from '@/router'
import { WarehouseReceivingOrderEnum } from '@/enums/modules/routes'
import { machine } from '@/models/createWarehouseReceivingOrder/create-order-machine'

import { CreateWarehouseReceivingOrderService } from '@/services/createWarehouseReceivingOrder/index'
import { mapDraftForCreate } from '@/mappers/receiving/draft/create'
import { mapFulfillmentCenterToApi } from '@/mappers/receiving/draft/fulfillmentCenter'

import { saveWro } from '@/models/createWarehouseReceivingOrder/commonActions/index'

import ServiceTypes from '@/enums/modules/fulfillmentCenter/serviceType.js'

import { validatePurchaseOrderNumber } from '@/components/createWarehouseReceivingOrder/steps/helper'

export const resetFcInStore = () => {
  const isWroCreated = store.getters[ModuleName + '/isWroCreated']
  if (!isWroCreated) store.dispatch(ModuleName + '/resetFc')
  else if (isWroCreated) machine.transition('INPUT')
}

export const resetEditFcInStore = () => {
  store.dispatch(ModuleName + '/resetFc')
  store.dispatch(ModuleName + '/resetPurchaseOrderNumber')
}

export const save = async (_state, draft) => {
  let service
  let mapper
  if (draft.id.length === 0) {
    service = CreateWarehouseReceivingOrderService.createWro
    mapper = mapDraftForCreate
  } else {
    service = CreateWarehouseReceivingOrderService.updateFc
    mapper = mapFulfillmentCenterToApi
  }
  const { success, response } = await saveWro({ service, mapper })(_state, draft)
  if (success && response.draftId) router.push({ name: WarehouseReceivingOrderEnum.CreateWarehouseReceivingOrder, params: { draftId: response.draftId } })
}

export const decideState = () => {
  const fc = store.getters[ModuleName + '/fulfillmentCenter']
  const pon = store.getters[ModuleName + '/purchaseOrderNumber']
  const receivingService = fc && fc.getService(ServiceTypes.Receiving)
  const valid = receivingService && receivingService.enabled && validatePurchaseOrderNumber(pon)
  if (valid) machine.transition('GOOD')
  else machine.transition('BAD')
}

